module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-de-DE.27fc5610.jpg";